import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Home, ArrowLeft, Search } from "lucide-react";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center px-4">
      {/* Decorative background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-secondary/50 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 text-center max-w-lg animate-fade-in">
        {/* 404 Number with decorative styling */}
        <div className="relative mb-8">
          <span className="text-[12rem] sm:text-[16rem] font-bold text-primary/10 leading-none select-none">
            404
          </span>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="bg-background/80 backdrop-blur-sm rounded-2xl px-8 py-4 shadow-lg border border-border/50">
              <Search className="w-12 h-12 text-primary mx-auto mb-2" />
              <p className="text-lg font-medium text-foreground">Page introuvable</p>
            </div>
          </div>
        </div>

        {/* Message */}
        <h1 className="text-2xl sm:text-3xl font-semibold text-foreground mb-4">
          Oups ! Cette page n'existe pas
        </h1>
        <p className="text-muted-foreground mb-8 text-lg">
          La page que vous recherchez a peut-être été déplacée, supprimée, ou n'a jamais existé.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button asChild size="lg" className="gap-2">
            <Link to="/">
              <Home className="w-4 h-4" />
              Retour à l'accueil
            </Link>
          </Button>
          <Button 
            variant="outline" 
            size="lg" 
            className="gap-2"
            onClick={() => window.history.back()}
          >
            <ArrowLeft className="w-4 h-4" />
            Page précédente
          </Button>
        </div>

        {/* Help text */}
        <p className="mt-12 text-sm text-muted-foreground">
          Besoin d'aide ?{" "}
          <Link to="/contact" className="text-primary hover:underline font-medium">
            Contactez-nous
          </Link>
        </p>
      </div>
    </div>
  );
};

export default NotFound;
